import React from 'react';
import { BoardMotif } from './BoardMotif';
type Tome = {
  number: string;
  title: string;
  promise: string;
  badge: string;
  contents: string[];
};
const tomes: Tome[] = [{
  number: '01',
  title: 'The Opening Weeks',
  promise: 'Launch the club and run your first full term — even with total beginners.',
  badge: 'bg-gold-deep',
  contents: ['The First-Day Flow: turn a crowd into a club in 10 minutes', 'The 3-Minute Reset to calm a noisy room without shouting', 'Meet the Pieces: one piece per session, zero confusion', 'Check, mate, castling and en passant — without the arguments', '13 session plans + 11 printable worksheets']
}, {
  number: '02',
  title: 'The Puzzle Engine',
  promise: 'Tactics and puzzle sessions that run themselves.',
  badge: 'bg-green',
  contents: ['The Blunder Check: the 3-question scan that stops free giveaways', 'Forks, pins, skewers and discovered attacks', 'The Pattern Ladder so no kid is bored or lost', 'The Rapid-Fire Puzzle Rotation for any group size', '12 session plans + 12 printable worksheets']
}, {
  number: '03',
  title: 'The Finish',
  promise: 'Checkmates and endgames your club can actually win.',
  badge: 'bg-crimson',
  contents: ['The Checkmate Staircase: queen, rook and two-rook mates', 'The Endgame Anchor and king-and-pawn essentials', 'Rook endings, simplifying when ahead and saving lost games', 'The Conversion Checklist: from “winning” to “won”', '12 session plans + 12 printable worksheets']
}, {
  number: '04',
  title: 'Smart Starts',
  promise: 'Openings your club can play on Monday — no memorizing.',
  badge: 'bg-navy-mid',
  contents: ['The Opening Compass: center, develop, castle', 'The Safe-Start Repertoire for White and Black', 'The Trap Shield: survive the first ten moves', 'The Opening Gauntlet session to rotate through five starts', '12 session plans + 12 printable worksheets']
}, {
  number: '05',
  title: 'The Plan',
  promise: 'Middlegame thinking kids can say out loud.',
  badge: 'bg-green-deep',
  contents: ['The Plan Finder: weakness, target, bring a piece', 'The Activity Check: outposts, open files, bad bishops', 'Pawn structure made simple for kids', 'The King-Attack Signal: three green lights before you attack', '12 session plans + 11 printable worksheets']
}, {
  number: '06',
  title: 'Game Day',
  promise: 'Tournaments, club games and real progress — plus the season finale.',
  badge: 'bg-navy',
  contents: ['The Club Tournament Engine: Swiss pairings without software', 'The Fun Variant Kit: bughouse, team chess, simuls', 'The Progress Tracker: proof of progress without a test', 'The Comeback Loop so kids re-enroll next term', '10 session plans + 11 printable worksheets']
}];
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="w-full bg-ice" data-id="element-257" data-mp="wol770h2k8ck">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-258" data-mp="11k0etaohh80j">
        <div className="text-center" data-id="element-259" data-mp="16k50df490sxm">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-260" data-mp="16l693cxsl3c6">
            The complete season
          </p>
          <h2 id="tomes-heading" className="chalk-underline mt-3 font-display text-ink text-[28px] sm:text-5xl" data-id="element-261" data-mp="dvzdomtmwtv5">
            Inside the pack — six volumes
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-262" data-mp="mwp2h6kh9jzd">
            Six volumes, one season in order. Every session in three lengths
            (20 / 45 / 60 min) and three levels.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-263" data-mp="3rbox0xkxfqq6">
          {tomes.map(tome => <article key={tome.number} className="flex flex-col overflow-hidden rounded-2xl border border-ice-dark bg-white shadow-card" data-id="element-264" data-mp="3vbfluvqw7ws2">
              <div className={`relative overflow-hidden ${tome.badge}`} data-id="element-265" data-mp="379atbhti2eua">
                <BoardMotif className="pointer-events-none absolute -right-4 -top-5 h-24 w-24 text-white/15" data-id="element-266" data-mp="3lxovdqj3dz9s" />
                <div className="relative flex items-center justify-between px-5 py-3.5" data-id="element-267" data-mp="3h78hk5bd0bmw">
                  <span className="text-xs font-bold uppercase tracking-[2px] text-white/85" data-id="element-268" data-mp="3uydakok825o9">
                    Volume {tome.number}
                  </span>
                  <span className="font-display text-3xl leading-none text-white" data-id="element-269" data-mp="3pyqw6bsnqjdv">
                    {tome.number}
                  </span>
                </div>
              </div>

              <div className="flex flex-1 flex-col p-6 pt-5" data-id="element-270" data-mp="3tdjxb35xax0">
                <h3 className="font-display text-xl leading-snug text-ink" data-id="element-271" data-mp="2ai8los5vi7kp">
                  {tome.title}
                </h3>
                <p className="mt-2 text-sm text-ink-soft" data-id="element-272" data-mp="25kguk0d1yphk">{tome.promise}</p>
                <ul className="mt-4 grid gap-2 border-t border-ice-dark pt-4" data-id="element-273" data-mp="l0uy9hc82fc3">
                  {tome.contents.map(item => <li key={item} className="flex gap-2.5 text-[13px] text-ink" data-id="element-274" data-mp="pz68vuacctvd">
                      <span className="mt-[5px] h-2 w-2 flex-none rounded-[1px] bg-gold" data-id="element-275" data-mp="bcd1db72csdq" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}